import { useState, useEffect } from 'react';
import { getSummary, getPosts, getLinks, getTimeseries } from '../APIs/analyticsApi';

const useDashboard = () => {
  const [summary,     setSummary]     = useState(null);
  const [posts,       setPosts]       = useState([]);
  const [totalPages,  setTotalPages]  = useState(1);
  const [links,       setLinks]       = useState([]);
  const [timeseries,  setTimeseries]  = useState([]);
  const [page,        setPage]        = useState(1);
  const [sort,        setSort]        = useState('recent');
  const [loading,     setLoading]     = useState(true);
  const [postsLoading,setPostsLoading]= useState(false);
  const [error,       setError]       = useState(null);

  // Load summary + links + chart once on mount
  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const [sumRes, linksRes, tsRes] = await Promise.all([
          getSummary(),
          getLinks(),
          getTimeseries(30),
        ]);
        setSummary(sumRes.data);
        setLinks(linksRes.data.links || []);
        setTimeseries(tsRes.data.timeseries || []);
      } catch {
        setError('Analytics temporarily unavailable, try again');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  // Reload posts when page or sort changes
  useEffect(() => {
    const load = async () => {
      setPostsLoading(true);
      try {
        const res = await getPosts(page, sort);
        setPosts(res.data.posts || []);
        setTotalPages(res.data.pages || 1);
      } catch {
        // silent — keep stale data visible
      } finally {
        setPostsLoading(false);
      }
    };
    load();
  }, [page, sort]);

  return {
    summary, posts, links, timeseries,
    page, setPage, totalPages,
    sort, setSort,
    loading, postsLoading, error,
  };
};

export default useDashboard;
